var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"connection-error"},[_vm._v(" "+_vm._s(_vm.$t('connection_error'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }